import React from "react";
import "./signup.css";
import Header from "../component/header";
import firebase from "firebase";
import Loader from "../component/loader";
import ReactToExcel from "react-html-table-to-excel";

export default class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      course: [],
      currentData: [],
      datafromfirebase: {},
      currentCourse: "",
      fiaOpen: false,
      accaOpen: false,
      caicapOpen: false,
      icmapOpen: false,
      ciaOpen: false,
      cimaOpen: false,
      icaewOpen: false,
      fia: [
        "FA1-Recording Financial Transactions",
        "FA2-Maintaining Financial Records",
        "MA1-Management Information",
        "MA2-Managing costs and Finances",
      ],
      acca: [
        "F1-Business and Technology (BT)",
        "F2-Management Accounting (MA)",
        "F3-Financial Accounting (FA)",
        "F4-Corporate and Business Law (LW)",
        "F5-Performance Management (PM)",
        "F6-Taxation (TX)",
        "F7-Financial Reporting (FR)",
        "F8-Audit and Assurance (AA)",
        "F9-Financial Management (FM)",
        "Strategic Business Leader (SBL)",
        "Strategic Business Reporting (SBR)",
        "Advanced Financial Management (AFM)",
        "Advanced Performance Management (APM)",
        "Advanced Taxation (ATX)",
        "Advanced Audit and Assurance (AAA)",
      ],
      caicap: [
        "AFC1-Functional English",
        "AFC1-Functional English",
        " AFC2-Business Communication",
        " AFC3-Quantitative Methods",
        " AFC4-Introduction To Information Technology",
        " CAF1-Introduction To Accounting",
        " CAF2-Introduction To Economics And Finance",
        " CAF3-Business Law",
        " CAF4-Business Management And Behavioral Studies",
        " CAF5-Financial Accounting And Reporting I",
        "  CAF6-Principles Of Taxation",
        " CAF7-Financial Accounting And Reporting Ii",
        " CAF8-Cost And Management Accounting",
        " CAF9-Audit And Assurance",
        " PCSC-Presentation And Communication Skills Course",
        "  CFAP1-Advanced Accounting And Financial Reporting",
        "  CFAP2-Corporate Laws",
        " CFAP3-Business Management And Strategy",
        " CFAP4-Business Finance Decisions",
        "  CFAP5-Advanced Taxation",
        " CFAP6-Audit, Assurance And Related Services",
        " MSA1-Financial Reporting And Assurance Professional Competence",
        " MSA2-Management Professional Competence",
      ],
      icmap: [
        "  O1-Fundamentals of Financial Accounting",
        " O2-Business Economics",
        "  O3-Business Communication and Report Writing",
        " O4-Fundamentals of Management",
        " O5-Business Mathematics & Statistical Inference",
        " O6-Commercial Laws",
        " M1-Fundamentals of Cost & Management Accounting",
        " M2-Enterprise Management",
        " M3-Management Information Systems",
        " M4-Financial Accounting & Corporate Reporting",
        " M5-Management Accounting",
        " M6-Corporate Governance, Business Laws & Ethics",
        " S1-Advanced Financial Accounting & Corporate Reporting",
        " S2-Audit & Assurance",
        " S3-Business Taxation",
        " S4-Strategic Management Accounting",
        " S5-Strategic Financial Management",
        " S6-Strategic Management",
      ],
      cia: [
        "  Part 1–Essentials of Internal Auditing",
        " Part 2-Practice of Internal Auditing, ",
        "  Part 3-Business Knowledge for Internal Auditing",
      ],
      cima: [
        " E1-Enterprise Operations",
        " P1-Performance Operations",
        " F1-Financial Operations",
        " E2-Enterprise Management",
        " P2-Performance Management",
        " F2-Financial Management",
        " E3-Enterprise Strategy",
        "  P3-Performance Strategy",
        " F3-Financial Strategy",
        " T4-Test of Professional Competence in Management Accounting (Part 1)",
        " T4-Test of Professional Competence in Management Accounting (Part 2)",
      ],
      icaew: [
        "  Certificate Level-Accounting",
        "  Certificate Level-Assurance",
        "  Certificate Level-Business, Technology and Finance",
        "  Certificate Level-Law",
        "  Certificate Level-Management Information",
        "  Certificate Level-Principles of Taxation",
        "  Professional Level-Audit and Assurance",
        "  Professional Level-Business Strategy and Technology",
        "  Professional Level-Financial Accounting and Reporting",
        "  Professional Level-Financial Management",
        "  Professional Level-Tax Compliance",
        "  Professional Level-Business Planning",
        "  Advanced Level-Corporate Reporting",
        "  Advanced Level-Strategic Business Management",
        "  Advanced Level-Case Study",
      ],
      programmArr: [],
    };
  }
  componentWillMount() {
    this.setState({ loader: true });
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.props.history.push("/admin");
        firebase
          .database()
          .ref("/")
          .child("forms")
          .on("value", (data) => {
            let student = data.val();
            this.setState({ datafromfirebase: student });
            let arr = [];
            for (var course in student) {
              arr.push(course);
              this.setState({ course: arr });
            }
          });
        this.setState({ loader: false });
      } else {
        this.setState({ loader: false });
        this.props.history.push("/login");
        // No user is signed in.
      }
    });
  }
  logout() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.props.history.push("/login");
      })
      .catch((error) => {
        // An error happened.
      });
  }
  getData(e) {
    console.log(e.target.value);
    this.setState({ currentData: [], currentCourse: e.target.value });
    const { datafromfirebase } = this.state;
    let ev = e.target.value;
    let data = datafromfirebase[ev];
    let arr = [];
    for (var a in data) {
      arr.push(data[a]);
    }
    if (e.target.value == "fia") {
      this.setState({ programmArr: this.state.fia });
    } else if (e.target.value == "acca") {
      this.setState({ programmArr: this.state.acca });
    } else if (e.target.value == "caicap") {
      this.setState({ programmArr: this.state.caicap });
    } else if (e.target.value == "icmap") {
      this.setState({ programmArr: this.state.icmap });
    } else if (e.target.value == "cia") {
      this.setState({ programmArr: this.state.cia });
    } else if (e.target.value == "cima") {
      this.setState({ programmArr: this.state.cima });
    } else if (e.target.value == "icaew") {
      this.setState({ programmArr: this.state.icaew });
    }
    arr.map((item) => {
      this.state.currentData.push(item);
    });
    this.setState({ currentData: arr });
  }
  updateCourse() {
    const {
      fiaOpen,
      accaOpen,
      caicapOpen,
      icmapOpen,
      ciaOpen,
      cimaOpen,
      icaewOpen,
    } = this.state;
    let obj = {
      fiaOpen,
      accaOpen,
      caicapOpen,
      icmapOpen,
      ciaOpen,
      cimaOpen,
      icaewOpen,
    };
    console.log(obj);
    firebase
      .database()
      .ref("/")
      .child("courseControl")
      .set(obj)
      .then((success) => {
        alert("Course Updated Successfully");
      });
  }
  render() {
    console.log(this.state.courseOpen);
    return (
      <div>
        {this.state.loader ? <Loader /> : null}
        <Header />
        <div className="container">
          <div className="row">
            <div className="col-md-3 p-2">
              <select onChange={(e) => this.getData(e)} className="inp">
                <option>Select Course</option>
                {this.state.course.map((item, i) => {
                  return <option key={i}>{item}</option>;
                })}
              </select>
            </div>
            <div className="col-md-3 p-2">
              <p>
                <button
                  class="customBtn btn-block"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  Select Course Registration
                </button>
              </p>
              <div class="collapse" id="collapseExample">
                <div class="card card-body">
                  <label className="lab">
                    <input
                      onChange={() => {
                        !this.state.fiaOpen
                          ? this.setState({ fiaOpen: true })
                          : this.setState({ fiaOpen: false });
                      }}
                      checked={this.state.fiaOpen}
                      type="checkBox"
                    />{" "}
                    FIA
                  </label>
                  <label className="lab">
                    <input
                      onChange={() => {
                        !this.state.accaOpen
                          ? this.setState({ accaOpen: true })
                          : this.setState({ accaOpen: false });
                      }}
                      checked={this.state.accaOpen}
                      type="checkBox"
                    />{" "}
                    ACCA
                  </label>
                  <label className="lab">
                    <input
                      onChange={() => {
                        !this.state.caicapOpen
                          ? this.setState({ caicapOpen: true })
                          : this.setState({ caicapOpen: false });
                      }}
                      checked={this.state.caicapOpen}
                      type="checkBox"
                    />{" "}
                    CA(ICAP)
                  </label>
                  <label className="lab">
                    <input
                      onChange={() => {
                        !this.state.icmapOpen
                          ? this.setState({ icmapOpen: true })
                          : this.setState({ icmapOpen: false });
                      }}
                      checked={this.state.icmapOpen}
                      type="checkBox"
                    />{" "}
                    ICMAP
                  </label>
                  <label className="lab">
                    <input
                      onChange={() => {
                        !this.state.ciaOpen
                          ? this.setState({ ciaOpen: true })
                          : this.setState({ ciaOpen: false });
                      }}
                      checked={this.state.ciaOpen}
                      type="checkBox"
                    />{" "}
                    CIA
                  </label>
                  <label className="lab">
                    <input
                      onChange={() => {
                        !this.state.cimaOpen
                          ? this.setState({ cimaOpen: true })
                          : this.setState({ cimaOpen: false });
                      }}
                      checked={this.state.cimaOpen}
                      type="checkBox"
                    />{" "}
                    CIMA
                  </label>
                  <label className="lab">
                    <input
                      onChange={() => {
                        !this.state.icaewOpen
                          ? this.setState({ icaewOpen: true })
                          : this.setState({ icaewOpen: false });
                      }}
                      checked={this.state.icaewOpen}
                      type="checkBox"
                    />{" "}
                    ICAEW
                  </label>
                  <div>
                    <button
                      onClick={() => this.updateCourse()}
                      className="customBtn btn-block"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 p-2">
              <ReactToExcel
                className="customBtn btn-block"
                table="table-to-xls"
                filename={this.state.currentCourse}
                sheet="sheet 1"
                buttonText="Download Excel"
              />
            </div>
            <div className="col-md-3 p-2">
              <button
                onClick={() => this.logout()}
                className="customBtn btn-block"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white shadow rounded p-4 m-3">
          <div>
            <table
              style={{ height: "60vh" }}
              id="table-to-xls"
              className="table-responsive tableShow"
            >
              <tr>
                <th>Name</th>
                <th>Student CNIC</th>
                <th>Father Name</th>
                <th>Father CNIC</th>
                <th>Residential Address</th>
                <th>Contact</th>
                <th>Whatsapp Number</th>
                <th>City</th>
                <th>Gender</th>
                <th>DOB</th>
                <th>Email</th>
                <th>Matric Institute</th>
                <th>Matric Total Marks</th>
                <th>Matric Obtained</th>
                <th>Matric Percentage</th>
                <th>Matric Year</th>
                {/* A level  */}
                <th>A Level Institute</th>
                <th>A Level Year</th>
                <th>A Level (A*)</th>
                <th>A Level (A)</th>
                <th>A Level (B)</th>
                <th>A Level (C)</th>
                <th>A Level (D)</th>
                <th>A Level (E)</th>
                <th>A Level (U)</th>

                {/* Intermediate */}
                <th>Inter Institute</th>
                <th>Inter Total Marks</th>
                <th>Inter Obtained</th>
                <th>Inter Percentage</th>
                <th>Inter Year</th>
                {/* O Level  */}
                <th>O Level Institute</th>
                <th>O Level Year</th>
                <th>O Level (A*)</th>
                <th>O Level (A)</th>
                <th>O Level (B)</th>
                <th>O Level (C)</th>
                <th>O Level (D)</th>
                <th>O Level (E)</th>
                <th>O Level (U)</th>
                {/* Graduation */}
                <th>Graduate Institute</th>
                <th>Graduate Total Marks</th>
                <th>Graduate Obtained</th>
                <th>Graduate Percentage</th>
                <th>Graduate Year</th>
                <th>Master Institute</th>
                <th>Master Total Marks</th>
                <th>Master Obtained</th>
                <th>Master Percentage</th>
                <th>Master Year</th>

                {this.state.programmArr.map((item, i) => {
                  return <th>{item}</th>;
                })}
                <th>Course</th>
                <th>Student Income</th>
                <th>Student Occupation</th>
                <th>Student Organization</th>
                <th>Student Designation</th>
                <th>Student Dependent</th>
                <th>Student Department</th>
                <th>Father Income</th>
                <th>Father Occupation</th>
                <th>Father Organization</th>
                <th>Father Designation</th>
                <th>Father Dependent</th>
                <th>Father Department</th>
              </tr>
              {this.state.currentData.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>{item.fullName}</td>
                    <td>{item.stnNic}</td>
                    <td>{item.fatherName}</td>
                    <td>{item.FatGuarCNIC}</td>
                    <td>{item.resAddress}</td>
                    <td>{item.contact}</td>
                    <td>{item.whatsapp}</td>
                    <td>{item.city}</td>
                    <td>{item.gender}</td>
                    <td>{item.date}</td>
                    <td>{item.email}</td>
                    {/* Matric  */}
                    <td>{item.matricInstitute}</td>
                    <td>{item.matricTotalMarks}</td>
                    <td>{item.matricMarks}</td>
                    <td>{item.matricPern}</td>
                    <td>{item.matricYear}</td>
                    {/* A level  */}
                    <td>{item.aLevelInstitute}</td>
                    <td>{item.aLevelYear}</td>
                    <td>{item.aPlusAlevel}</td>
                    <td> {item.aAlevel}</td>
                    <td> {item.bAlevel}</td>
                    <td> {item.cAlevel}</td>
                    <td> {item.dAlevel}</td>
                    <td> {item.eAlevel}</td>
                    <td> {item.uAlevel}</td>
                    {/* Intermediate  */}
                    <td>{item.interInstitute}</td>
                    <td>{item.interTotalMarks}</td>
                    <td>{item.interMarks}</td>
                    <td>{item.interPern}</td>
                    <td>{item.interYear}</td>
                    {/* O level  */}
                    <td>{item.olevelInstitute}</td>
                    <td>{item.olevelYear}</td>
                    <td>{item.aPlusAlevel}</td>
                    <td>{item.aOlevel}</td>
                    <td>{item.bOlevel}</td>
                    <td>{item.cOlevel}</td>
                    <td>{item.dOlevel}</td>
                    <td>{item.eOlevel}</td>
                    <td>{item.uOlevel}</td>
                    {/* Graduation  */}
                    <td>{item.GraduationInstitute}</td>
                    <td>{item.GraduationTotalMarks}</td>
                    <td>{item.GraduationMarks}</td>
                    <td>
                      {(item.GraduationMarks / item.GraduationTotalMarks) * 100}
                    </td>
                    <td>{item.GraduationYear}</td>
                    <td>{item.MasterInstitute}</td>
                    <td>{item.MasterTotalMarks}</td>
                    <td>{item.MasterMarks}</td>
                    <td>{(item.MasterMarks / item.MasterTotalMarks) * 100}</td>
                    <td>{item.MasterYear}</td>
                    {this.state.programmArr.map((e, i) => {
                      {
                        return !item.selectedCourseList.indexOf(e) ? (
                          <td>Yes</td>
                        ) : (
                          <td>No</td>
                        );
                      }
                    })}
                    <td>{this.state.currentCourse}</td>
                    <td>{item.stdIncome}</td>
                    <td>{item.stdOccupation}</td>
                    <td>{item.stdOrganization}</td>
                    <td>{item.stdDesignation}</td>
                    <td>{item.stdDependent}</td>
                    <td>{item.stdDepartment}</td>
                    <td>{item.fthIncome}</td>
                    <td>{item.fthOccupation}</td>
                    <td>{item.fthOrganization}</td>
                    <td>{item.fthDesignation}</td>
                    <td>{item.fthDependent}</td>
                    <td>{item.fthDepartment}</td>
                  </tr>
                );
              })}
            </table>
          </div>
        </div>
      </div>
    );
  }
}
